import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("line", { x1: "10", y1: "17", x2: "10", y2: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("polyline", { points: "15 8 10 3 5 8", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconArrowUp.js.map